// extracted by mini-css-extract-plugin
module.exports = {"stats":"stats_stats__27uC2"};